import { stringify } from 'qs';

export function httpBodyOptions(payload: any, encodedJSON = false) {
  return {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: stringify(encodedJSON ? { json: JSON.stringify(payload) } : payload),
  };
}
